export default "__VITE_ASSET__CkYq4mg9__"